import React from 'react';
import styled from 'styled-components';
import { FaHeart, FaHandHoldingHeart } from 'react-icons/fa';
const DonateSection = styled.section`
  background-color: #fff;
  color: #ea384c;
  padding: 5rem 1.5rem;
  text-align: center;
  position: relative;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #ea384c 0%, #ff6b6b 100%);
  }
`;
const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;
const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  position: relative;
  display: inline-block;
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background-color: #ea384c;
  }
`;
const DonateText = styled.p`
  max-width: 700px;
  margin: 0 auto 2.5rem;
  font-size: 1.125rem;
  line-height: 1.7;
  color: #4a5568;
`;
const DonationOptions = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2.5rem;
`;
const DonationAmount = styled.button`
  padding: 1rem;
  background-color: #fff;
  border: 2px solid #ea384c;
  border-radius: 8px;
  color: #ea384c;
  font-weight: 600;
  font-size: 1.25rem;
  transition: all 0.3s ease;
  cursor: pointer;
  &:hover {
    background-color: #ea384c;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(234, 56, 76, 0.2);
  }
`;
const DonateButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 2rem;
  background-color: #ea384c;
  color: white;
  text-decoration: none;
  font-weight: bold;
  font-size: 1.125rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(234, 56, 76, 0.2);
  svg {
    margin-right: 0.5rem;
    font-size: 1.25rem;
  }
  &:hover {
    background-color: #dc2626;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(234, 56, 76, 0.3);
  }
`;
const ImpactMessage = styled.div`
  margin-top: 3rem;
  padding: 2rem;
  background-color: #fff5f5;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(234, 56, 76, 0.1);
`;
const ImpactIcon = styled.div`
  color: #ea384c;
  font-size: 2rem;
  margin-bottom: 1rem;
`;
const ImpactText = styled.p`
  color: #4a5568;
  font-size: 1rem;
  margin-bottom: 0;
`;
const Donate = () => {
  const donationAmounts = ['$10', '$25', '$50', '$100'];
  return (
    <DonateSection id='donate'>
      <Container>
        <SectionTitle>
          Support Our Mission <FaHeart style={{ color: '#ea384c', fontSize: '0.8em' }} />
        </SectionTitle>
        <DonateText>
          Your generosity helps us continue our mission and serve the community.
          Every donation, big or small, makes a difference in transforming lives and
          building a stronger community of faith.
        </DonateText>
        
        <DonationOptions>
          {donationAmounts.map((amount, index) => (
            <DonationAmount key={index}>
              {amount}
            </DonationAmount>
          ))}
        </DonationOptions>
        <DonateButton href="/donate">
          <FaHandHoldingHeart /> Donate Now
        </DonateButton>
        <ImpactMessage>
          <ImpactIcon>
            <FaHeart />
          </ImpactIcon>
          <ImpactText>
            "For God loves a cheerful giver." - 2 Corinthians 9:7
          </ImpactText>
        </ImpactMessage>
      </Container>
    </DonateSection>
  );
};
export default Donate;